import '../../../../types/product.js';
import { isSubscriptionPurchase } from '../../../../types/typeguards.js';

const isConfiguratorValid = (state)=>{
    const { purchaseType  } = state.configurations;
    if (isSubscriptionPurchase(purchaseType)) {
        return !!isDeliveryIntervalValid(state);
    }
    // Single purchase is always valid
    return true;
};
const isDeliveryIntervalValid = ({ configurations  })=>{
    const { purchaseType , subscriptionPurchaseConfigurations  } = configurations;
    if (isSubscriptionPurchase(purchaseType)) {
        return subscriptionPurchaseConfigurations.deliveryInterval !== null;
    }
    return undefined;
};
const selectors = {
    isConfiguratorValid,
    isDeliveryIntervalValid
};

export { selectors };
//# sourceMappingURL=selectors.js.map
